<template>
    <div class="container">
    <h1 class="contact-me-msg" data-aos="fade-up">Contact Me</h1>
    <p class="contact-me-msg-1" data-aos="fade-up">You can contact me online on Linkedin or Facebook. Otherwise, feel free to contact me directly.</p>
   
        <div class="row align-items-center" style="margin-bottom:80px;" data-aos="flip-up">
            <div class="col-sm-12 col-lg-12 ">
                <div class="contact-container card" style="padding: 0px; border-radius: 15px; height: 100%;">
                    <div class="row">   
                         <div class="backcl d-none d-md-block d-lg-block  col-md-5 col-lg-5">
                            <div class="content"
                                style=" margin-top: 20px;margin-right: 30px; margin-left: 30px;color: white; ">
                                <h3>Contact Information</h3>
                                <p style="color: #6990F2;">Fill up the form and we will get back to you within 24 hours.
                                </p>
                                <div style="color: #DAD4EB;">
                                    <div class="m-contact"><i class="fas fa fa-phone"
                                            style="color: #6990F2; margin-right: 15px;"></i>+91 95950 68833</div>
                                    <div class="m-contact"><i class="fas fa fa-envelope"
                                            style="color: #6990F2; margin-right: 15px;"></i>vrushu00@gmail.com</div>
                                    <div class="m-contact"><i class="fas fa fa-map-marker"
                                            style="color: #6990F2; margin-right: 15px;"></i> Pune, Maharashtra</div>
                                </div>
                               
                            </div>
                        </div>
                        <div class="col-sm-12 col-lg contact-card" >
                             <form @submit="onSubmit">
                                    <div class="row" style="margin-top: 20px;">
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="firstname" style="color: #000018;">First Name</label>
                                                <input type="text" class="form-control" v-model="firstname" id="firstname" placeholder="John" autocomplete="off">
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="lastname" style="color: #000018;">Last Name</label>
                                                <input type="text" class="form-control" v-model="lastname" id="lastname" placeholder="Doe" autocomplete="off">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-top: 20px;">
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="email" style="color: #000018;">Email</label>
                                                <input type="email" class="form-control" v-model="email" name="email" id="email" placeholder="username@email.com" autocomplete="off">
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="phone" style="color: #000018;">Phone</label>
                                                <input type="number" class="form-control" v-model="phone" id="phone" placeholder="12345 67890" maxlength="10" autocomplete="off">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="position: relative; margin-top: 20px;">
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label for="message" style="color: #000018;">Message</label>
                                                <textarea class="form-control" v-model="message" name="message" id="message" rows="2" placeholder="Write your message.."></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12" align="right" style="margin: 00px 0px 30px 0px;">
                                            <input type="submit" value="Send Message" class="cv-btn" data-aos="flip-up"/>
                                        </div>
                                    </div>
                                    <input type="hidden" name="_autoresponse" value="Your message has been sent to Vrushaket, he will contact you soon. Thank you!!"/>
                                    <input type="hidden" name="_template" value="table"/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  
    <div class="modal fade" id="successModal" tabindex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog  modal-dialog-centered" role="document">
            <div class="container" style="padding: 20px;">
                <center>
                    <i class="fa fa-check-circle" style="font-size: 80px;color: #A3DA8D;margin: 20px;"></i>
                    <h4 style="padding: 0px;margin: 0px;">Message send successfully.</h4> 
                    <p style="font-size: 14px;color: gray;padding: 0px;margin-top: 0px;margin-bottom: 20px;">We will get back to you shortly. Thank You!</p>  
                </center>
           </div>
        </div>
      </div>
</template>

<script>
 export default {
        name: "ContactBlock",
        mounted() {
            AOS.init({
                duration: 1200,
                easing: 'ease', 
                once: false, 
            });           
        },
         data(){
                return{
                        firstname: '',
                        lastname: '',
                        email: '',
                        phone: '',
                        message: '',
                    }
            },
            methods:{
                onSubmit(e){
                    e.preventDefault()
                    
                    var fields = []  
                    if (this.firstname == "") {
                        fields.push("firstname") 
                    }
                    if (this.lastname == "") {
                        fields.push("lastname")
                    }
                    if (this.email == "") {
                        fields.push("email")
                    }
                    if (this.phone == "") {
                        fields.push("phone")
                    }
                    if (this.message == "") {
                        fields.push("message")
                    }

                    if(this.email!="" && this.validateEmail(this.email) == false){
                        alert("Error: Email is invalid.")
                    }
                    if(this.phone!="" && this.validatePhone(this.phone) == false){
                                alert("Error: Phone is invalid.")
                    }
                    if(fields.length == 0){
                      
                        this.axios.post('https://formsubmit.co/ajax/vrushu00@gmail.com',{
                            name: this.firstname+" "+this.lastname,
                            message: this.message +" \n\nPhone: "+this.phone,
                            email : this.email,
                        })
                        .then((response) => {
                                 if(response.status == 200){
                                        // $('#successModal').modal('show');
                                        alert('Message send successfully.\nWe will get back to you shortly.\nThank You!');
                                    
                                    this.firstname= ''
                                    this.lastname= ''
                                    this.email= ''
                                    this.phone= ''
                                    this.message= ''
                                }
                        });


                    }else{
                            
                        var flds = ''; 
                        var x ='';
                        for(x in fields){
                            flds += fields[x]+", ";
                        }
                        alert(flds+" must be filled."); 
                    }
                },
                validateEmail(email){
                    var re = /\S+@\S+\.\S+/;
                    return re.test(email);
                },
                validatePhone(phone) {
                    const regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    return (regex.test(phone))
                }
            },
    };
</script>

<style scoped>
    .contact-container{
        border-width: 0px;
            box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    }
    .contact-me-msg{
        text-align: center;
        margin-top: 100px;
        font-weight: bold;
    }
    .contact-me-msg-1{
        text-align: center;
        color:#999999;
    }

        .contact-card{
            position: relative; 
            border-radius: 15px; 
            margin: 10px 20px 10px 10px; 
            padding:20px;
        }

        .btn:focus {
            border-color: inherit;
            -webkit-box-shadow: none;
            box-shadow: none;
        }

        .form-control:focus {
            border-color: inherit;
            -webkit-box-shadow: none;
            box-shadow: none;
            border-color: #6990F2;
            border-width: 2px;
        }

        .form-control {
            display: flex;
            cursor: pointer;
            border-radius: 0px;
            border-top: 0px;
            border-left: 0px;
            border-right: 0px;
            border-width: 2px;
        }
        .backcl {
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='600' height='750' preserveAspectRatio='none' viewBox='0 0 600 750'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1018%26quot%3b)' fill='none'%3e%3crect width='600' height='750' x='0' y='0' fill='rgba(0%2c 0%2c 92%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c364.528C67.499%2c373.927%2c135.194%2c334.461%2c185.161%2c288.117C231.35%2c245.277%2c249.101%2c181.634%2c263.354%2c120.27C275.5%2c67.979%2c261.186%2c16.186%2c260.791%2c-37.496C260.319%2c-101.623%2c303.259%2c-177.925%2c260.804%2c-225.988C218.24%2c-274.175%2c137.455%2c-245.123%2c73.326%2c-249.726C23.534%2c-253.3%2c-25.222%2c-263.052%2c-73.399%2c-249.975C-122.266%2c-236.711%2c-162.258%2c-206.425%2c-201.963%2c-175.002C-250.085%2c-136.918%2c-308.837%2c-105.179%2c-329.416%2c-47.363C-351.317%2c14.168%2c-349.4%2c88.252%2c-315.544%2c144.104C-282.453%2c198.693%2c-207.076%2c204.232%2c-154.745%2c240.788C-99.483%2c279.391%2c-66.766%2c355.231%2c0%2c364.528' fill='%2300004a'%3e%3c/path%3e%3cpath d='M600 1038.337C657.715 1038.25 717.249 1039.059 767.314 1010.345 818.6320000000001 980.913 862.7339999999999 934.437 879.8820000000001 877.818 896.287 823.651 860.332 769.515 857.369 712.996 853.994 648.624 895.154 578.433 861.31 523.573 827.495 468.759 753.675 454.054 690.357 442.272 631.292 431.282 569.876 435.585 514.571 459.056 462.808 481.024 429.94 528.3050000000001 391.323 569.1800000000001 350.813 612.059 302.975 648.9639999999999 282.79 704.392 259.931 767.165 241.41199999999998 840.343 270.714 900.38 299.931 960.242 370.925 985.109 432.363 1010.8489999999999 485.67 1033.182 542.204 1038.424 600 1038.337' fill='%2300006e'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1018'%3e%3crect width='600' height='750' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");
            position: relative; 
            /* data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='600' height='750' preserveAspectRatio='none' viewBox='0 0 600 750'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1018%26quot%3b)' fill='none'%3e%3crect width='600' height='750' x='0' y='0' fill='rgba(0%2c 0%2c 92%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c364.528C67.499%2c373.927%2c135.194%2c334.461%2c185.161%2c288.117C231.35%2c245.277%2c249.101%2c181.634%2c263.354%2c120.27C275.5%2c67.979%2c261.186%2c16.186%2c260.791%2c-37.496C260.319%2c-101.623%2c303.259%2c-177.925%2c260.804%2c-225.988C218.24%2c-274.175%2c137.455%2c-245.123%2c73.326%2c-249.726C23.534%2c-253.3%2c-25.222%2c-263.052%2c-73.399%2c-249.975C-122.266%2c-236.711%2c-162.258%2c-206.425%2c-201.963%2c-175.002C-250.085%2c-136.918%2c-308.837%2c-105.179%2c-329.416%2c-47.363C-351.317%2c14.168%2c-349.4%2c88.252%2c-315.544%2c144.104C-282.453%2c198.693%2c-207.076%2c204.232%2c-154.745%2c240.788C-99.483%2c279.391%2c-66.766%2c355.231%2c0%2c364.528' fill='%2300004a'%3e%3c/path%3e%3cpath d='M600 1038.337C657.715 1038.25 717.249 1039.059 767.314 1010.345 818.6320000000001 980.913 862.7339999999999 934.437 879.8820000000001 877.818 896.287 823.651 860.332 769.515 857.369 712.996 853.994 648.624 895.154 578.433 861.31 523.573 827.495 468.759 753.675 454.054 690.357 442.272 631.292 431.282 569.876 435.585 514.571 459.056 462.808 481.024 429.94 528.3050000000001 391.323 569.1800000000001 350.813 612.059 302.975 648.9639999999999 282.79 704.392 259.931 767.165 241.41199999999998 840.343 270.714 900.38 299.931 960.242 370.925 985.109 432.363 1010.8489999999999 485.67 1033.182 542.204 1038.424 600 1038.337' fill='%2300006e'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1018'%3e%3crect width='600' height='750' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e */
            border-radius: 10px; 
            margin: 10px 10px 10px 22px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            display: none;
        }

        .m-contact {
            padding: 15px;
        }
        .cv-btn{
            margin-top:40px;
            border-width: 0px;
            background-color: #2f58cd;
            border-radius: 30px;
            padding: 10px 20px 10px 20px;
            color: white;
        }
        .cv-btn:hover{
            
            cursor: pointer;
             transform: scale(1.1);
        }

        @media only screen and (max-width: 700px) {
            .m-contact {
                padding: 10px;
            } 
        }
    </style>